// Tela do layout de impressão: /settings/layout-impressao
//
// A mesma aba "Layout de Impressão" de Lojas, em página inteira. A rota fica de
// pé como deep link, mas quem sabe carregar, escolher o ambiente e salvar é a
// section — esta página é só a casca, no mesmo molde de SitePage.tsx.
//
// O que estava aqui (buscar, escolher o PRIMEIRO ambiente sem perguntar, salvar
// e pintar todo aviso de verde, inclusive o do fallback) mudou de lugar, não
// sumiu: está em components/configuration/sections/storesSection/LayoutImpressao.

import React from "react";
import LayoutImpressao from "../../components/configuration/sections/storesSection/LayoutImpressao";
import { useDecryptedInfoToken } from "../../hooks/useDecryptedInfoToken";

const LayoutImpressaoPage: React.FC = () => {
  const infoToken = useDecryptedInfoToken();
  return <LayoutImpressao decryptedInfoToken={infoToken} />;
};

export default LayoutImpressaoPage;
